import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
// Reducer Thunk
export const getCompanySaleOders = createAsyncThunk('CompanySaleOders/todosFetched', async (loadData) => {
    try {
        let response
        let docList
        response = await axios.create(axiosConfig).post(`api/report/CompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

const CompanySaleOdersSlice = createSlice({
    name: 'CompanySaleOders',
    initialState: {
        allPageLoad: [],
        TotalDelivery: 0,
        TotalQty: 0,
        TotalTurnover: 0,
        Loading: true,
        SalesByEmployee: [],
        QtyByPro2: []
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getCompanySaleOders.pending, (state, action) => {
            state.Loading = true
        })
        builder.addCase(getCompanySaleOders.fulfilled, (state, action) => {
            state.allPageLoad = action.payload
            let result = [];
            (action.payload).reduce(function (res, value) {
                if (!res[value.SlpName]) {
                    res[value.SlpName] = { SlpName: value.SlpName, lastName: value.lastName, GTotal: 0 };
                    result.push(res[value.SlpName])
                }
                res[value.SlpName].GTotal += value.GTotal;
                return res;
            }, {});
            var sortByGTotal = result.sort(function(a, b) {
                return b.GTotal - a.GTotal;
            });
            
            var topTen = sortByGTotal.slice(0,10);



            state.SalesByEmployee = topTen

            let QtyByPro2 = [];
            (action.payload).reduce(function (res, value) {
                if (value.U_Pro_2 !== 'Phí gia công')
                {
                    if (!res[value.U_Pro_2]) {
                        res[value.U_Pro_2] = { U_Pro_2: value.U_Pro_2, val: 0 };
                        QtyByPro2.push(res[value.U_Pro_2])
                    }
                    res[value.U_Pro_2].val += value.InvQty;
                }
                return res;
            }, {});
            state.QtyByPro2 = QtyByPro2

            let counter = 0
            const TotalDeliveryGroup = (action.payload).reduce(function (res, value) {
                if (!res[value.U_S1No]) {
                    res[value.U_S1No] = { U_S1No: value.U_S1No, Count: 0 };
                    result.push(res[value.U_S1No])
                    counter += 1;
                }
                res[value.U_S1No].Count += 1;
                return res;
            }, {});
            state.TotalDelivery = counter

            counter = 0
            state.TotalQty = (action.payload).reduce((res, value) => counter += value.InvQty, 0)

            counter = 0
            state.TotalTurnover = (action.payload).reduce((res, value) => counter += value.GTotal, 0)
            

            state.Loading = false
        })
        builder.addCase(getCompanySaleOders.rejected, (state, action) => {
            state.Loading = false
        })
    }
})

// Reducer
const CompanySaleOdersReducer = CompanySaleOdersSlice.reducer

// Selector
export const CompanySaleOdersSelector = (state) => state.CompanySaleOdersReducer
// Action export
export const {
} = CompanySaleOdersSlice.actions

// Export reducer
export default CompanySaleOdersReducer